import React from "react";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";
import Experts from "./Experts";

import "./ITStaffing.css";

import staffingImg from "./ITstaffing.png";

import {
  FaUsers,
  FaUserTie,
  FaLaptopCode,
  FaHandshake,
  FaJava,
  FaReact,
  FaNodeJs,
  FaAws,
  FaDocker,
  FaDatabase,
  FaRobot,
  FaMobileAlt,
  FaSearch,
  FaUserCheck,
  FaComments,
  FaBriefcase,
  FaClock,
  FaHeadset
} from "react-icons/fa";

export default function ITStaffing() {

  const navigate = useNavigate();

  const handleStartHiring = () => {
    navigate("/", {
      state: {
        scrollTo: "contact",
      },
    });
  };

  return (
    <>
      <Navbar />

      {/* ================= HERO ================= */}

      <section className="its-hero">

        <div className="its-left">

          <span className="its-tag">
            IT STAFFING
          </span>

          <h1>
            Build Your Team
            <br />
            <span>With Skilled IT</span>
            <br />
            Professionals
          </h1>

          <p>
            E-Forum Software Solutions helps organizations hire
            experienced IT professionals through permanent hiring,
            contract staffing and dedicated development teams.
          </p>

          <div className="its-features">

            <div>
              <FaUsers />
              Dedicated Teams
            </div>

            <div>
              <FaUserTie />
              Expert Professionals
            </div>

            <div>
              <FaLaptopCode />
              Latest Technologies
            </div>

            <div>
              <FaHandshake />
              Flexible Hiring
            </div>

          </div>

          <div className="its-buttons">

            <button
              className="its-btn-primary"
              onClick={handleStartHiring}
            >
              Hire Talent
            </button>

            <Link
              to="experts"
              smooth={true}
              duration={700}
              offset={-80}
            >
              <button className="its-btn-secondary">
                Talk To Our Experts
              </button>
            </Link>

          </div>

        </div>

        <div className="its-right">

          <img
            src={staffingImg}
            alt="IT Staffing"
          />

        </div>

      </section>
            {/* ================= ABOUT ================= */}

      <section className="its-about">

        <div className="its-about-left">

          <span className="section-tag">
            IT TALENT SOLUTIONS
          </span>

          <h2>
            Connecting Businesses
            <span> With Top IT Talent</span>
          </h2>

          <p>
            We help startups, SMEs and enterprises build high-performing
            technology teams by providing skilled IT professionals across
            multiple domains and technologies.
          </p>

          <p>
            Whether you need a single developer, an entire project team,
            or long-term technical resources, we deliver the right talent
            quickly and efficiently.
          </p>

          <div className="staffing-models">

            <div className="staff-card">

              <FaUserTie className="staff-icon" />

              <div>

                <h3>Permanent Hiring</h3>

                <p>
                  Full-time technology professionals for long-term business growth.
                </p>

              </div>

            </div>

            <div className="staff-card">

              <FaUsers className="staff-icon" />

              <div>

                <h3>Contract Staffing</h3>

                <p>
                  Flexible professionals for short-term projects and critical requirements.
                </p>

              </div>

            </div>

            <div className="staff-card">

              <FaLaptopCode className="staff-icon" />

              <div>

                <h3>Dedicated Teams</h3>

                <p>
                  Build complete software development teams managed by experts.
                </p>

              </div>

            </div>

            <div className="staff-card">

              <FaHandshake className="staff-icon" />

              <div>

                <h3>Managed Resources</h3>

                <p>
                  End-to-end staffing with continuous support and workforce management.
                </p>

              </div>

            </div>

          </div>

        </div>

        <div className="its-about-right">

          <img
            src={staffingImg}
            alt="IT Professionals"
          />

        </div>

      </section>
            {/* ================= TECHNOLOGIES ================= */}

      <section className="its-technologies">

        <div className="section-heading">

          <span>TECHNOLOGY EXPERTISE</span>

          <h2>Technologies We Hire For</h2>

          <p>
            We provide highly skilled professionals across modern
            technologies to help organizations build innovative,
            scalable and secure software solutions.
          </p>

        </div>

        <div className="tech-grid">

          <div className="tech-card">

            <FaJava className="tech-icon" />

            <h3>Java</h3>

            <p>
              Spring Boot, Microservices, Enterprise Applications
            </p>

          </div>

          <div className="tech-card">

            <FaReact className="tech-icon" />

            <h3>React</h3>

            <p>
              ReactJS, Next.js and Frontend Development
            </p>

          </div>

          <div className="tech-card">

            <FaNodeJs className="tech-icon" />

            <h3>Node.js</h3>

            <p>
              Express.js, REST APIs and Backend Development
            </p>

          </div>

          <div className="tech-card">

            <FaAws className="tech-icon" />

            <h3>Cloud</h3>

            <p>
              AWS, Microsoft Azure and Google Cloud Platform
            </p>

          </div>

          <div className="tech-card">

            <FaDocker className="tech-icon" />

            <h3>DevOps</h3>

            <p>
              Docker, Kubernetes and CI/CD Automation
            </p>

          </div>

          <div className="tech-card">

            <FaDatabase className="tech-icon" />

            <h3>Database</h3>

            <p>
              MySQL, PostgreSQL, Oracle and MongoDB
            </p>

          </div>

          <div className="tech-card">

            <FaRobot className="tech-icon" />

            <h3>AI & ML</h3>

            <p>
              Artificial Intelligence, Machine Learning and Generative AI
            </p>

          </div>

          <div className="tech-card">

            <FaMobileAlt className="tech-icon" />

            <h3>Mobile Apps</h3>

            <p>
              Android, Flutter, React Native and iOS Development
            </p>

          </div>

        </div>

      </section>
            {/* ================= RECRUITMENT PROCESS ================= */}

      <section className="its-process">

        <div className="section-heading">

          <span>OUR PROCESS</span>

          <h2>Our Recruitment Process</h2>

          <p>
            We follow a structured hiring process to ensure every
            professional meets your technical, business and cultural
            requirements.
          </p>

        </div>

        <div className="process-grid">

          <div className="process-card">

            <div className="process-icon">
              <FaSearch />
            </div>

            <h3>Source Talent</h3>

            <p>
              We identify experienced professionals through our extensive
              talent network and recruitment channels.
            </p>

          </div>

          <div className="process-arrow">
            →
          </div>

          <div className="process-card">

            <div className="process-icon">
              <FaUserCheck />
            </div>

            <h3>Technical Screening</h3>

            <p>
              Every candidate is evaluated for technical expertise,
              communication skills and cultural fit.
            </p>

          </div>

          <div className="process-arrow">
            →
          </div>

          <div className="process-card">

            <div className="process-icon">
              <FaComments />
            </div>

            <h3>Client Interview</h3>

            <p>
              We coordinate interviews and simplify the hiring process
              for both clients and candidates.
            </p>

          </div>

          <div className="process-arrow">
            →
          </div>

          <div className="process-card">

            <div className="process-icon">
              <FaBriefcase />
            </div>

            <h3>Deployment</h3>

            <p>
              Professionals are onboarded quickly with continuous
              support throughout the engagement.
            </p>

          </div>

        </div>

      </section>
            {/* ================= WHY CHOOSE US ================= */}

      <section className="its-why">

        <div className="section-heading">

          <span>WHY CHOOSE E-FORUM</span>

          <h2>Your Trusted IT Staffing Partner</h2>

          <p>
            We combine industry expertise, a strong talent network and
            a customer-first approach to deliver professionals who add
            value from day one.
          </p>

        </div>

        <div className="why-grid">

          <div className="why-card">

            <FaClock className="why-icon" />

            <h3>Fast Hiring</h3>

            <p>
              Access qualified IT professionals quickly through our
              extensive recruitment network.
            </p>

          </div>

          <div className="why-card">

            <FaUserCheck className="why-icon" />

            <h3>Verified Talent</h3>

            <p>
              Every candidate undergoes technical evaluation,
              communication assessment and background verification.
            </p>

          </div>

          <div className="why-card">

            <FaHandshake className="why-icon" />

            <h3>Flexible Engagement</h3>

            <p>
              Permanent hiring, contract staffing, dedicated teams and
              project-based resource models.
            </p>

          </div>

          <div className="why-card">

            <FaHeadset className="why-icon" />

            <h3>Dedicated Support</h3>

            <p>
              Our recruitment specialists stay engaged throughout the
              hiring lifecycle to ensure successful onboarding.
            </p>

          </div>

          <div className="why-card">

            <FaLaptopCode className="why-icon" />

            <h3>Technology Experts</h3>

            <p>
              We specialize in sourcing professionals across modern
              software technologies and enterprise platforms.
            </p>

          </div>

          <div className="why-card">

            <FaUsers className="why-icon" />

            <h3>Scalable Teams</h3>

            <p>
              Easily scale your engineering team up or down based on
              changing project requirements.
            </p>

          </div>

        </div>

      </section>
            {/* ================= COMPANY STATS ================= */}

      <section className="its-stats">

        <div className="section-heading">

          <span>OUR ACHIEVEMENTS</span>

          <h2>Delivering Talent That Drives Success</h2>

          <p>
            We help organizations build stronger technology teams
            through reliable staffing solutions and experienced
            professionals.
          </p>

        </div>

        <div className="stats-grid">

          <div className="stat-card">

            <h2>25+</h2>

            <span>Years Experience</span>

            <p>
              Delivering trusted IT staffing and technology services.
            </p>

          </div>

          <div className="stat-card">

            <h2>500+</h2>

            <span>IT Professionals</span>

            <p>
              Successfully deployed across multiple technologies
              and business domains.
            </p>

          </div>

          <div className="stat-card">

            <h2>100+</h2>

            <span>Enterprise Clients</span>

            <p>
              Trusted by startups, SMEs and global organizations.
            </p>

          </div>

          <div className="stat-card">

            <h2>98%</h2>

            <span>Client Satisfaction</span>

            <p>
              Long-term partnerships built through quality staffing.
            </p>

          </div>

        </div>

      </section>

      {/* ================= CALL TO ACTION ================= */}

      <section className="its-cta">

        <div className="cta-content">

          <h2>
            Looking For Skilled IT Professionals?
          </h2>

          <p>
            Whether you need one developer, an entire engineering team
            or long-term staffing support, E-Forum Software Solutions
            is ready to help.
          </p>

          <div className="its-buttons">

            <button
              className="its-btn-primary"
              onClick={handleStartHiring}
            >
              Hire Talent
            </button>

            <Link
              to="experts"
              smooth={true}
              duration={700}
              offset={-80}
            >
              <button className="its-btn-secondary">
                Talk To Our Experts
              </button>
            </Link>

          </div>

        </div>

      </section>

      {/* ================= EXPERTS ================= */}

      <Experts />

      <Footer />

    </>

  );

}